export const SET_PRODUCTS_VARIATIONS = "SET_PRODUCTS_VARIATIONS"
export const REMOVE_PRODUCT_VARIATIONS = 'REMOVE_PRODUCT_VARIATION'
export const ADD_VARIATION = 'ADD_VARIATION'